import { Controller } from '@hotwired/stimulus'

// Generic controller for form fields (e.g. a <select>) that should submit
// their enclosing form as soon as they change, such as a turbo-frame-scoped
// contract picker. Mirrors the requestSubmit() pattern already used by
// hr_portal/reporting_window_controller.js.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
